import { useRouter } from 'next/router';

export default function useForceError() {
  const { query } = useRouter();

  return query['vdp-break-spinner']
    ? () =>
        // prettier-ignore
        // @ts-ignore
        ({}).foo.bar
    : null;
}
